// Adresse inconnue du site public.
import React from "react";
import { Link } from "react-router-dom";
import Tiggy from "../site/Tiggy";

export default function PageIntrouvable() {
	return (
		<section className="gs-page">
			<div className="gs-quadrillage gs-quadrillage--page" />
			<div className="gs-conteneur">
				<div className="gs-carte gs-page-carte">
					<Tiggy pose="reflexion" taille={150} />
					<h1 className="gs-page-titre">Cette page n'existe pas</h1>
					<p className="gs-texte">Le lien est peut-être ancien, ou l'adresse contient une faute de frappe.</p>
					<Link to="/" className="gs-btn gs-btn--plein">
						Revenir à l'accueil
					</Link>
				</div>
			</div>
		</section>
	);
}
